import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import BookingSection from './components/BookingSection';
import LocationInfo from './components/LocationInfo';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <Services />
        <WhyChooseUs />
        <BookingSection />
        <LocationInfo />
      </main>
      <Footer />
    </div>
  );
}